import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  type?: 'website' | 'article' | 'course';
  image?: string;
}

export function SEO({
  title = "Shut Up & Close — Formation Setting & Closing B2C & B2B",
  description = "Formation professionnelle en Setting et Closing pour vendre sans forcer. Méthode terrain pour B2C et B2B. Par Camille Vega.",
  canonical = "https://camillevega.fr/",
  type = "website",
  image = "https://camillevega.fr/images/og-image.jpg"
}: SEOProps) {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Shut Up & Close",
    "description": "Formation professionnelle en Setting et Closing",
    "url": "https://camillevega.fr",
    "logo": "https://camillevega.fr/favicon.svg",
    "founder": {
      "@type": "Person",
      "name": "Camille Vega",
      "jobTitle": "Formatrice en Closing et Setting",
      "url": "https://camillevega.fr"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "60 rue François Premier",
      "addressLocality": "Paris",
      "postalCode": "75008",
      "addressCountry": "FR"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+33-6-95-77-11-67",
      "contactType": "Customer Service",
      "email": "camille@camillevega.com",
      "availableLanguage": "French"
    },
    "sameAs": [
      "https://www.linkedin.com/in/camille-vega",
      "https://www.instagram.com/camille.vega"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Shut Up & Close",
    "url": "https://camillevega.fr",
    "description": description,
    "publisher": {
      "@type": "Organization",
      "name": "Camille Vega — SARL",
      "logo": {
        "@type": "ImageObject",
        "url": "https://camillevega.fr/favicon.svg"
      }
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
}
